import { accordions } from '../components/_accordion.js';
export let nav = {
	lenis: null,
	active: function( lenis ){
		if( lenis ){
			nav.lenis = lenis;
		}
		let $btnScrolls	= document.querySelectorAll("a[data-scroll]");
		let $btnMenu 	= document.querySelectorAll("[data-menu]");
		let $btnCloseMenu 	= document.querySelectorAll("[data-menu-close]");
		
		if( $btnScrolls ){
			//multiple handlers
			const eventListenersMultiple = [
				{ elements: $btnScrolls, type: "click", handler: nav.scrollTo },
				{ elements: $btnMenu, type: "click", handler: nav.toggleMenu },
				{ elements: $btnCloseMenu, type: "click", handler: nav.closeMenu }
			];
			eventListenersMultiple.forEach( ( el ) => {
				el.elements.forEach( ( element )=> {
					element.removeEventListener(el.type, el.handler, false);
					element.addEventListener(el.type, el.handler, false);
				});
			});
		}
		accordions.init();
	},
	toggleMenu: function(e){
		let $html = document.documentElement;
		if( !$html.classList.contains("show-menu") ){
			$html.classList.add("show-menu");
			if( nav.lenis ){
				nav.lenis.stop();
			}
		}else{
			nav.closeMenu();
		}
	},
	closeMenu: function(){
		let $html = document.documentElement;
		$html.classList.remove("show-menu");
		if( nav.lenis ){
			nav.lenis.start();
		}
		nav.getScrollBarWidth();
	},
	scrollTo: function(e){
		e.preventDefault();
		let $html 	= document.documentElement;
		let $this 	= this;
		let id 		= this.getAttribute("href");
		let $dom 	= document.querySelector(id);
		let isBrand = $dom.classList.contains("s-brands");
		//console.log(isBrand);
		let posY 	= Math.floor( $dom.getBoundingClientRect().top + window.pageYOffset);
		if( isBrand ){
			posY = posY - document.querySelector(".c-list_categories").clientHeight;
		}
		let isMobile = window.matchMedia('(max-width: 864px)').matches;
		nav.closeMenu();
		scrollToElementWithEasing(posY, 600);
		function scrollToElementWithEasing(targetY, duration = 800, callback = () => {}) {
			const startY = window.scrollY;
			const diff = targetY - startY;
			const startTime = performance.now();
			
			function step(currentTime) {
				const time = Math.min(1, (currentTime - startTime) / duration);
				const eased = easeInOutQuad(time);
				window.scrollTo(0, startY + diff * eased);
			
				if (time < 1) {
					requestAnimationFrame(step);
				} else {
					callback();
				}
			}
			 requestAnimationFrame(step);
		}
		function backairsteppy($as){
			$this.classList.remove("jump");
		}
	},
	getScrollBarWidth: function(){
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
	}
}
function easeInOutQuad(t) {
	return t < 0.5
	? 2 * t * t
	: -1 + (4 - 2 * t) * t;
}